var _metadata, _defs, _g, _g2, _g3, _g4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgField(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 77.20950764457365 77.041675851714",
    width: 77.20950764457365,
    height: 77.041675851714,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null)), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", {
    className: "style-fonts"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    transform: "translate(31.452736616545018 49.48532666560996) rotate(315 20 2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 0 C9.74 0, 18.49 0, 39 0 C39.67 0, 40 0.33, 40 1 C40 1.42, 40 1.84, 40 3 C40 3.67, 39.67 4, 39 4 C29.58 4, 20.16 4, 1 4 C0.33 4, 0 3.67, 0 3 C0 2.49, 0 1.97, 0 1 C0 0.33, 0.33 0, 1 0",
    stroke: "none",
    strokeWidth: 0,
    fill: "#005e79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 0 C10.82 0, 20.65 0, 39 0 M1 0 C11.75 0, 22.51 0, 39 0 M39 0 C39.67 0, 40 0.33, 40 1 M39 0 C39.67 0, 40 0.33, 40 1 M40 1 C40 1.79, 40 2.58, 40 3 M40 1 C40 1.8, 40 2.6, 40 3 M40 3 C40 3.67, 39.67 4, 39 4 M40 3 C40 3.67, 39.67 4, 39 4 M39 4 C29.28 4, 19.56 4, 1 4 M39 4 C26.94 4, 14.87 4, 1 4 M1 4 C0.33 4, 0 3.67, 0 3 M1 4 C0.33 4, 0 3.67, 0 3 M0 3 C0 2.59, 0 2.17, 0 1 M0 3 C0 2.39, 0 1.77, 0 1 M0 1 C0 0.33, 0.33 0, 1 0 M0 1 C0 0.33, 0.33 0, 1 0",
    stroke: "#005e79",
    strokeWidth: 2,
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    transform: "translate(5.698510241829418 49.46958124823776) rotate(225 20 2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 0 C9.26 0, 17.53 0, 39 0 C39.67 0, 40 0.33, 40 1 C40 1.45, 40 1.9, 40 3 C40 3.67, 39.67 4, 39 4 C29.69 4, 20.39 4, 1 4 C0.33 4, 0 3.67, 0 3 C0 2.56, 0 2.12, 0 1 C0 0.33, 0.33 0, 1 0",
    stroke: "none",
    strokeWidth: 0,
    fill: "#005e79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 0 C13.16 0, 25.32 0, 39 0 M1 0 C14 0, 27 0, 39 0 M39 0 C39.67 0, 40 0.33, 40 1 M39 0 C39.67 0, 40 0.33, 40 1 M40 1 C40 1.42, 40 1.85, 40 3 M40 1 C40 1.57, 40 2.13, 40 3 M40 3 C40 3.67, 39.67 4, 39 4 M40 3 C40 3.67, 39.67 4, 39 4 M39 4 C29.32 4, 19.63 4, 1 4 M39 4 C25.21 4, 11.42 4, 1 4 M1 4 C0.33 4, 0 3.67, 0 3 M1 4 C0.33 4, 0 3.67, 0 3 M0 3 C0 2.28, 0 1.57, 0 1 M0 3 C0 2.45, 0 1.9, 0 1 M0 1 C0 0.33, 0.33 0, 1 0 M0 1 C0 0.33, 0.33 0, 1 0",
    stroke: "#005e79",
    strokeWidth: 2,
    fill: "none"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    transform: "translate(5.556349186104043 23.556349186104043) rotate(135 20 2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 0 C13.58 0, 26.16 0, 39 0 C39.67 0, 40 0.33, 40 1 C40 1.68, 40 2.36, 40 3 C40 3.67, 39.67 4, 39 4 C30.02 4, 21.05 4, 1 4 C0.33 4, 0 3.67, 0 3 C0 2.37, 0 1.73, 0 1 C0 0.33, 0.33 0, 1 0",
    stroke: "none",
    strokeWidth: 0,
    fill: "#e0115f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 0 C14.59 0, 28.19 0, 39 0 M1 0 C10.04 0, 19.09 0, 39 0 M39 0 C39.67 0, 40 0.33, 40 1 M39 0 C39.67 0, 40 0.33, 40 1 M40 1 C40 1.64, 40 2.28, 40 3 M40 1 C40 1.69, 40 2.37, 40 3 M40 3 C40 3.67, 39.67 4, 39 4 M40 3 C40 3.67, 39.67 4, 39 4 M39 4 C26.92 4, 14.84 4, 1 4 M39 4 C27.03 4, 15.07 4, 1 4 M1 4 C0.33 4, 0 3.67, 0 3 M1 4 C0.33 4, 0 3.67, 0 3 M0 3 C0 2.55, 0 2.11, 0 1 M0 3 C0 2.4, 0 1.8, 0 1 M0 1 C0 0.33, 0.33 0, 1 0 M0 1 C0 0.33, 0.33 0, 1 0",
    stroke: "#e0115f",
    strokeWidth: 2,
    fill: "none"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    transform: "translate(31.65315845846961 24.166558821116695) rotate(45 20 2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 0 C11.77 0, 22.54 0, 39 0 C39.67 0, 40 0.33, 40 1 C40 1.77, 40 2.55, 40 3 C40 3.67, 39.67 4, 39 4 C26.17 4, 13.33 4, 1 4 C0.33 4, 0 3.67, 0 3 C0 2.42, 0 1.85, 0 1 C0 0.33, 0.33 0, 1 0",
    stroke: "none",
    strokeWidth: 0,
    fill: "#e0115f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 0 C14.34 0, 27.68 0, 39 0 M1 0 C14.32 0, 27.65 0, 39 0 M39 0 C39.67 0, 40 0.33, 40 1 M39 0 C39.67 0, 40 0.33, 40 1 M40 1 C40 1.42, 40 1.84, 40 3 M40 1 C40 1.72, 40 2.44, 40 3 M40 3 C40 3.67, 39.67 4, 39 4 M40 3 C40 3.67, 39.67 4, 39 4 M39 4 C24.84 4, 10.67 4, 1 4 M39 4 C29.83 4, 20.66 4, 1 4 M1 4 C0.33 4, 0 3.67, 0 3 M1 4 C0.33 4, 0 3.67, 0 3 M0 3 C0 2.28, 0 1.57, 0 1 M0 3 C0 2.28, 0 1.57, 0 1 M0 1 C0 0.33, 0.33 0, 1 0 M0 1 C0 0.33, 0.33 0, 1 0",
    stroke: "#e0115f",
    strokeWidth: 2,
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgField);
export default __webpack_public_path__ + "static/media/field.b270a861aabfa35e233a3c066e67aef4.svg";
export { ForwardRef as ReactComponent };